import { render, staticRenderFns } from "./NueraBlogsContent.vue?vue&type=template&id=45d2f1ea"
import script from "./NueraBlogsContent.vue?vue&type=script&lang=js"
export * from "./NueraBlogsContent.vue?vue&type=script&lang=js"
import style0 from "./NueraBlogsContent.vue?vue&type=style&index=0&id=45d2f1ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports